import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';

const ServicoDetalhePage = () => {
  const { slug } = useParams();
  const [service, setService] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServiceDetail = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('produtos')
          .select('*')
          .eq('slug', slug)
          .single();

        if (error) throw error;
        setService(data);
      } catch (error) {
        console.error('Erro ao carregar detalhes:', error);
      } finally {
        setLoading(false);
      }
    };

    if (slug) fetchServiceDetail();
  }, [slug]);

  if (loading) return <div className="min-h-screen flex items-center justify-center">Carregando...</div>;
  if (!service) return <div className="min-h-screen flex items-center justify-center">Produto não encontrado.</div>;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <WhatsAppButton />

      {/* Breadcrumb */}
      <div className="pt-28 pb-6 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <nav className="flex items-center gap-2 text-sm font-poppins text-gray-600">
            <Link to="/" className="hover:text-accent-red cursor-pointer">Início</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/servicos" className="hover:text-accent-red cursor-pointer">Serviços</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-primary font-medium">{service.name}</span>
          </nav>
        </div>
      </div>

      {/* Product Detail */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Gallery */}
            <div>
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg mb-4">
                <img
                  src={service.image}
                  alt={service.name}
                  className="w-full h-[500px] object-cover"
                />
              </div>
              {/* Renderiza miniaturas se houver mais de uma imagem no array 'images' */}
              <div className="grid grid-cols-4 gap-4">
                {service.images?.length > 1 && service.images.map((img: string, idx: number) => (
                  <div key={idx} className="bg-white rounded-xl overflow-hidden shadow cursor-pointer">
                    <img src={img} alt="" className="w-full h-24 object-cover" />
                  </div>
                ))}
              </div>
            </div>

            {/* Info */}
            <div>
              <h1 className="font-montserrat font-bold text-4xl text-primary mb-6">{service.name}</h1>
              <p className="text-gray-700 text-lg mb-6">{service.description}</p>
              
              {/* Preço dinâmico */}
              <div className="text-2xl font-bold text-accent-red mb-8">
                {service.price_info || 'Preço sob consulta'}
              </div>

              {/* Características (Features) */}
              <div className="bg-white rounded-2xl p-6 mb-8 shadow-md">
                <h3 className="font-montserrat font-bold text-xl text-primary mb-4">Características</h3>
                <ul className="grid grid-cols-2 gap-3">
                  {service.features?.map((feature: string, index: number) => (
                    <li key={index} className="flex items-center gap-2 text-gray-700">
                      <i className="ri-check-line text-accent-yellow text-xl"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* CTA WhatsApp */}
              <a
                href={`https://wa.me/5521992215234?text=Olá!%20Gostaria%20de%20um%20orçamento%20para%20${service.name}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 w-full bg-accent-red text-white py-5 rounded-2xl font-bold shadow-xl"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                Solicitar Orçamento
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicoDetalhePage;